import FormRowPasswordInput from './FormRowPasswordInput';

export default FormRowPasswordInput;
